import React, { useState } from 'react';
import { firestore } from '../firebase';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Typography, TextField, Select, MenuItem, FormControl, InputLabel, Button } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
	buttons: {
		display: 'flex',
		justifyContent: 'flex-end',
	},
	button: {
		marginTop: theme.spacing(3),
		marginLeft: theme.spacing(1),
	},
}));

export default function AddressForm(props) {

	const classes = useStyles()
	const [name,setname] = useState('')
	const [last_name,setlast_name] = useState('')
	const [email,setemail] = useState('')
	const [phone,setphone] = useState('')
	const [modality,setmodality] = useState('Presencial')
	const [isIcf,setisIcf] = useState('')
	const [country,setcountry] = useState('')
	const [membership,setmembership] = useState('')
	
	return (
		<React.Fragment>
			<Typography variant="h6" gutterBottom>
				Formulario de Inscripción
			</Typography>
			<Grid container spacing={3}>
				<Grid item xs={12} sm={6}>
					<TextField
						value={name}
						onChange={e => setname(e.target.value)}
						required
						label="Nombre"
						fullWidth
					/>
				</Grid>
				<Grid item xs={12} sm={6}>
					<TextField
						value={last_name}
						onChange={e => setlast_name(e.target.value)}
						required
						label="Apellidos"
						fullWidth
					/>
				</Grid>
				<Grid item xs={12} sm={6}>
					<TextField
						value={email}
						onChange={e => setemail(e.target.value)}
						required
						label="Email"
						fullWidth
						autoComplete="email"
					/>
				</Grid>
				<Grid item xs={12} sm={6}>
					<TextField
						value={phone}
						onChange={e => setphone(e.target.value)}
						required
						label="Teléfono"
						fullWidth
						autoComplete="phone"
					/>
				</Grid>
				<Grid item xs={12} sm={6}>
					<FormControl required fullWidth>
						<InputLabel ref={null} htmlFor="outlined-age-simple">
							Modalidad
						</InputLabel>
						<Select
							value={modality}
							onChange={e => setmodality(e.target.value)}
							labelWidth={0}
							inputProps={{
								name: 'age',
								id: 'outlined-age-simple',
							}}
						>
							<MenuItem value="Presencial">Presencial</MenuItem>
							<MenuItem value="Online">Online (Streaming)</MenuItem>
						</Select>
					</FormControl>
				</Grid>
				{modality === 'Presencial' ? <Grid item xs={12} sm={6}>
					<FormControl required fullWidth>
						<InputLabel ref={null} htmlFor="outlined-age-simple">
							¿Eres miembro de ICF?
						</InputLabel>
						<Select
							value={isIcf}
							onChange={e => setisIcf(e.target.value)}
							labelWidth={0}
							inputProps={{
								name: 'age',
								id: 'outlined-age-simple',
							}}
						>
							<MenuItem value="">
								<em>** Selecciona una opción **</em>
							</MenuItem>
							<MenuItem value="Si">Si</MenuItem>
							<MenuItem value="No">No</MenuItem>
						</Select>
					</FormControl>
				</Grid> : ''}
				{isIcf==='Si' ? <Grid item xs={12} sm={6}>
					<TextField
						value={country}
						onChange={e => setcountry(e.target.value)}
						required
						label="¿De qué país eres miembro?"
						fullWidth
					/>
				</Grid> : ''}
				{isIcf==='Si' ? <Grid item xs={12} sm={6}>
					<TextField
						value={membership}
						onChange={e => setmembership(e.target.value)}
						required
						label="No. de membresía ICF"
						fullWidth
					/>
				</Grid> : ''}
			</Grid>
			<div className={classes.buttons}>
				<Button
					variant="contained"
					color="primary"
					onClick={handleSubmit}
					className={classes.button}
				>
					Continuar
				</Button>
			</div>
		</React.Fragment>
	)

	async function handleSubmit() {
		try {
			if (name && last_name && email && phone && modality) {
				const ref = firestore.collection('inscriptions').doc()
				if (modality === 'Presencial') {
					if (isIcf === 'Si') {
						if (country && membership) {
							const item = {
								name,
								last_name,
								email,
								phone,
								isIcf,
								country,
								membership,
								id: ref.id,
								description: `Competencias y algo más que hacen a un coach profesional - inscripción precencial miembro de ICF`,
								modality
							}
							ref.set(item).then(() => {
								window.location.replace('https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=ZQDSE9FFJ8WRA')
							})
						} else {
							alert('Escribe el país del que eres miembro y tu número de membresía para continuar')
						}
					} else {
						const item = {
							name,
							last_name,
							email,
							phone,
							isIcf,
							country,
							membership,
							id: ref.id,
							description: `Competencias y algo más que hacen a un coach profesional - inscripción preceincial no miembro de ICF`,
							modality
						}
						ref.set(item).then(() => {
							window.location.replace('https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=8KDZSNTHBCVSW')
						})
					}
				} else {
					const item = {
						name,
						last_name,
						email,
						phone,
						isIcf,
						country,
						membership,
						amount: 33,
						id: ref.id,
						description: `Competencias y algo más que hacen a un coach profesional - inscripción modo online`,
						modality
					}
					ref.set(item).then(() => {
						window.location.replace('https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=E8MYSLJQ8K58N')
					})
				}
			} else {
				alert('Completa todos los campos para continuar')
			}
		} catch (error) {
			alert(error.message)
		}
	}
}